import React from 'react'
import { Card, Stack, Typography } from '@mui/material'
import { J2Caution } from '@e3dc-react/icons'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

export interface Props {
  errors: { title: string; message: string }[]
}

/**
 * This component displays a list of message with title.
 */
const WarningBanner: React.FC<Props> = ({ errors }) => {
  const { t } = useCustomTranslation()

  return (
    <Card
      sx={{
        backgroundColor: 'warning.light',
        p: 2,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
        width: '100%',
      }}
    >
      <J2Caution sx={{ color: 'warning.main', flexGrow: 0 }} />
      <Stack>
        {errors.map(({ title, message }, index) => (
          <Stack key={`${title}-${index}`}>
            <Typography sx={{ textAlign: 'center' }} variant="h3">
              {t(title)}
            </Typography>

            <Typography sx={{ textAlign: 'center' }} variant="body1">
              {t(message)}
            </Typography>
            {index < errors.length - 1 && (
              <Typography sx={{ textAlign: 'center' }} variant="body1">
                -
              </Typography>
            )}
          </Stack>
        ))}
      </Stack>
    </Card>
  )
}

export default WarningBanner
